module.exports = __webpack_public_path__ + "static/img/eec-group5.94c8655f.png";